var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCartBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 27.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1-2",
    "data-name": "\\u5716\\u5C64 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.61,24.61a2.37,2.37,0,0,0,.72,1.74,2.45,2.45,0,0,0,3.49,0,2.46,2.46,0,0,0-3.49-3.48A2.4,2.4,0,0,0,24.61,24.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.63,2.82a1.18,1.18,0,0,0-.86-.36H7.67c0-.09,0-.25-.08-.49s-.09-.43-.11-.57A4.07,4.07,0,0,0,7.34.89,1.71,1.71,0,0,0,7.09.42,1.54,1.54,0,0,0,6.7.12,1.2,1.2,0,0,0,6.15,0H1.23A1.15,1.15,0,0,0,.37.37,1.15,1.15,0,0,0,0,1.23a1.19,1.19,0,0,0,.37.87,1.18,1.18,0,0,0,.86.36H5.15L8.56,18.29l-.4.73q-.36.66-.57,1.14a2.14,2.14,0,0,0-.21.76,1.17,1.17,0,0,0,.37.87,1.19,1.19,0,0,0,.86.37H28.3a1.25,1.25,0,0,0,1.23-1.24,1.25,1.25,0,0,0-1.23-1.23H10.62a3.8,3.8,0,0,0,.46-1.23A2.18,2.18,0,0,0,11,18c0-.16-.07-.33-.12-.51s-.07-.33-.08-.41l20.08-2.35A1.26,1.26,0,0,0,32,13.54V3.69A1.19,1.19,0,0,0,31.63,2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38,24.61a2.37,2.37,0,0,0,.72,1.74,2.45,2.45,0,0,0,3.49,0,2.46,2.46,0,0,0-1.75-4.2,2.46,2.46,0,0,0-2.46,2.46Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCartBlack);
export default __webpack_public_path__ + "static/media/icon_cart-black.8ecd18be6b2e5aaa069698dce236087a.svg";
export { ForwardRef as ReactComponent };